import {
  optionsCheckpoint
} from "@modules/JourneyBuilder/Bricks/Checkpoints";

import {
  withWhitelistedCheckpointTypes
} from "./brick-initializer-helpers";

/**
 * Initialize the given goal brick
 * @param {JourneyBrick} brick
 */
const initialize = brick => {
  const _registerConnection = brick.registerConnection;
  brick.registerConnection = function(connection) {
    _registerConnection.apply(this, arguments);

    //https://datanext.atlassian.net/browse/DPN-3199
    //Goal brick connections only accept options checkpoints
    withWhitelistedCheckpointTypes(connection, [
        optionsCheckpoint
    ]);
  }
}

export {initialize};